export const CUSTOMER_REGISTER_FIELD_ENUM = {
  TAX_ID: 'TAX_ID',
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ADDRESS: 'ADDRESS',
} as const;
export type CUSTOMER_REGISTER_FIELD_ENUM =
  (typeof CUSTOMER_REGISTER_FIELD_ENUM)[keyof typeof CUSTOMER_REGISTER_FIELD_ENUM];
